import { render, staticRenderFns } from "./AdditionalImages.vue?vue&type=template&id=59c7a032&"
import script from "./AdditionalImages.vue?vue&type=script&lang=js&"
export * from "./AdditionalImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports